import { ICouponServiceProps } from "@/api_framework/api_modals/coupon";
import Input from "@/app/components/ui/Inputs/Input/index";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useCouponCARTTypeListAPI } from "@/app/hooks/api_hooks/coupon/useCouponCARTTypeListAPI";
import { useCouponDetailsAPI } from "@/app/hooks/api_hooks/coupon/useCouponDetailsAPI";
import { useCouponUpdationAPI } from "@/app/hooks/api_hooks/coupon/useCouponUpdationAPI";
import useFormValidations from "@/app/hooks/useFormValidations";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { Switch } from "@headlessui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";

const booleanArray = [
  {
    id: "LIMITED",
    title: "Enter Value",
  },
  {
    id: "UNLIMITED",
    title: "UNLIMITED",
  },
];

export interface ICouponServiceUsageListPropsFiled {
  usage_limit: string;
  is_usage_limit_applicable: string;
  limit_per_user: string;
  is_limit_per_user_applicable: string;
  usage_level: string;
  auto_applicable: boolean;
  is_visible: boolean;
  vms_auto_applicable: boolean;
  vms_visible: boolean;
  status: boolean;
}

const CouponUsageComponent = () => {
  const navigation = useNavigate();
  const [params, _setParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { forOnlyPercentageAndNumberRegex } = useFormValidations();
  const { execute: updateCoupons } = useCouponUpdationAPI();
  const { execute: fetchCouponDetails, couponDetails } = useCouponDetailsAPI();
  const { execute: fetcCartTpe, cartType } = useCouponCARTTypeListAPI();
  const coupon_id = params.get("coupon_id");
  const is_membership_coupon = couponDetails?.is_membership_coupon;
  const is_exhaustible_coupon = couponDetails?.is_exhaustible;
  const cartTypeItem = useSelectMenuReducer(cartType, "label", "value");
  const coupon_type = couponDetails?.coupon_type;
  const showAppVisibility = coupon_type === "SERVICE" || coupon_type === "QC COUPON" || coupon_type === "BOM";
  // Base coupons are always hidden + non-auto-apply; the 4 toggles are locked off.
  const isBase = couponDetails?.base_coupon ?? false;

  const formHook = useForm<ICouponServiceUsageListPropsFiled>({
    mode: "onChange",
    defaultValues: {
      is_usage_limit_applicable: "LIMITED",
      is_limit_per_user_applicable: "LIMITED",
      usage_level: "CART_LEVEL",
      auto_applicable: false,
      is_visible: false,
      vms_auto_applicable: false,
      vms_visible: false,
    },
  });

  const onSubmit = (data: ICouponServiceUsageListPropsFiled) => {
    if (data.is_usage_limit_applicable === "LIMITED" && parseInt(data?.usage_limit) === 0) {
      toast.error("Usage Limit Per Coupon  0 can't be accepted");
      return null;
    }
    if (data.is_limit_per_user_applicable === "LIMITED" && parseInt(data?.limit_per_user) === 0) {
      toast.error("Usage Limit Per User 0 can't be accepted");
      return null;
    }
    const constructedBody: ICouponServiceProps = {
      page_step: "usage_details",
      coupon_id: coupon_id,
      usage_limit: data.is_usage_limit_applicable === "UNLIMITED" ? null : parseInt(data.usage_limit),
      is_usage_limit_applicable: data.is_usage_limit_applicable === "UNLIMITED" ? false : true,
      limit_per_user: data.is_limit_per_user_applicable === "UNLIMITED" ? null : parseInt(data.limit_per_user),
      is_limit_per_user_applicable: data.is_limit_per_user_applicable === "UNLIMITED" ? false : true,
      usage_level: data.usage_level,
      auto_applicable: data.auto_applicable,
      is_visible: data.is_visible,
      vms_auto_applicable: data.usage_level === "CART_LEVEL" ? false : data.vms_auto_applicable,
      vms_visible: data.vms_visible,
      status: data.status ? "ACTIVE" : "INACTIVE",
    };
    setIsSubmitting(true);
    updateCoupons(constructedBody).then(({ status }) => {
      setIsSubmitting(false);
      if (status) {
        navigation(`/app/coupon-service/coupon-list`);
      }
    });
  };

  useEffect(() => {
    if (coupon_id) {
      fetchCouponDetails(coupon_id);
    }
  }, [coupon_id]);

  useEffect(() => {
    fetcCartTpe();
  }, []);

  useEffect(() => {
    const usagesLimit = couponDetails;
    if (usagesLimit) {
      formHook.setValue("usage_limit", couponDetails?.usage_limit?.toString());
      (formHook.setValue(
        "is_usage_limit_applicable",
        couponDetails.is_usage_limit_applicable ? "LIMITED" : "UNLIMITED",
      ),
        formHook.setValue("limit_per_user", couponDetails.limit_per_user?.toString()),
        formHook.setValue(
          "is_limit_per_user_applicable",
          couponDetails.is_limit_per_user_applicable ? "LIMITED" : "UNLIMITED",
        ));
      if (couponDetails.usage_level) {
        formHook.setValue("usage_level", couponDetails.usage_level);
      } else {
        formHook.setValue("usage_level", couponDetails.discount_level === "CART" ? "CART_LEVEL" : "ITEM_LEVEL");
      }
      if (couponDetails?.auto_applicable) {
        formHook.setValue("auto_applicable", couponDetails?.auto_applicable);
      } else {
        formHook.setValue("auto_applicable", false);
      }
      if (couponDetails?.is_visible) {
        formHook.setValue("is_visible", couponDetails?.is_visible);
      } else {
        formHook.setValue("is_visible", false);
      }
      if (couponDetails?.vms_auto_applicable) {
        formHook.setValue("vms_auto_applicable", couponDetails?.vms_auto_applicable);
      } else {
        formHook.setValue("vms_auto_applicable", false);
      }
      if (couponDetails?.vms_visible) {
        formHook.setValue("vms_visible", couponDetails?.vms_visible);
      } else {
        formHook.setValue("vms_visible", false);
      }
      formHook.setValue("status", couponDetails?.status === "ACTIVE" ? true : false);
    }
  }, [couponDetails]);

  const handelBackStepper = () => {
    navigation(`/app/coupon-service/coupon-creation?page_step=details_and_schedule&&coupon_id=${coupon_id}`);
  };

  return (
    <div className="p-4 bg-white">
      <div className="p-3 py-3">
        <h2 className="text-sm font-semibold">Usage Limits</h2>
        <form className="w-full mt-3" onSubmit={formHook.handleSubmit(onSubmit)}>
          <div className="mt-4 flex flex-col gap-4 w-full">
            <div className="flex items-center py-2">
              <div className="w-2/12">
                <p>
                  Usage Limit Per Coupon <span className="text-red-400">*</span>
                </p>
              </div>
              <div className="w-1/3">
                {is_membership_coupon ? (
                  <p className="text-xs text-black">Unlimited</p>
                ) : (
                  <div className="grid grid-cols-2 gap-3">
                    <SearchableSelectMenu
                      errorMessages={[{ message: "", type: "required" }]}
                      onSelectItem={(item) => {
                        if (item) {
                          formHook.setValue("is_usage_limit_applicable", item.id);
                        }
                      }}
                      fieldError={formHook.formState.errors.is_usage_limit_applicable}
                      register={formHook.register("is_usage_limit_applicable", { required: true })}
                      selectItems={booleanArray}
                      placeholder="Select"
                      showTooltips={true}
                      showTypedErrors={true}
                      showDropdownIcon={true}
                      defaultSelected={
                        booleanArray?.filter((oc) => oc.id === formHook.watch("is_usage_limit_applicable"))[0]
                      }
                      listBoxClassName="w-36"
                      className="text-gray-800"
                      containerClassName="w-full"
                    />
                    {formHook.watch("is_usage_limit_applicable") === "LIMITED" && (
                      <Input
                        className="text-xs"
                        placeholder="Enter Value"
                        register={formHook.register("usage_limit", {
                          required: true,
                          ...(forOnlyPercentageAndNumberRegex.validations as any),
                        })}
                        fieldError={formHook.formState.errors.usage_limit}
                        errorMessages={[{ message: "", type: "required" }, forOnlyPercentageAndNumberRegex.errors]}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center pb-3">
              <div className="w-2/12">
                <p>
                  Usage Limit Per User <span className="text-red-400">*</span>
                </p>
              </div>
              <div className="w-1/3">
                {!is_exhaustible_coupon && is_membership_coupon ? (
                  <p className="text-xs text-black">Unlimited</p>
                ) : (
                  <div className="grid grid-cols-2 gap-3">
                    <SearchableSelectMenu
                      errorMessages={[{ message: "Country is required", type: "required" }]}
                      onSelectItem={(item) => {
                        if (item) {
                          formHook.setValue("is_limit_per_user_applicable", item.id);
                        }
                      }}
                      fieldError={formHook.formState.errors.is_limit_per_user_applicable}
                      register={formHook.register("is_limit_per_user_applicable", { required: true })}
                      selectItems={booleanArray}
                      placeholder="Select"
                      showTooltips={true}
                      showTypedErrors={true}
                      showDropdownIcon={true}
                      defaultSelected={
                        booleanArray?.filter((oc) => oc.id === formHook.watch("is_limit_per_user_applicable"))[0]
                      }
                      listBoxClassName="w-36"
                      className="text-gray-800"
                      containerClassName="w-full"
                    />
                    {formHook.watch("is_limit_per_user_applicable") === "LIMITED" && (
                      <Input
                        className="text-xs"
                        placeholder="Enter Value"
                        register={formHook.register("limit_per_user", {
                          required: true,
                          ...(forOnlyPercentageAndNumberRegex.validations as any),
                        })}
                        fieldError={formHook.formState.errors.limit_per_user}
                        errorMessages={[{ message: "", type: "required" }, forOnlyPercentageAndNumberRegex.errors]}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
            {couponDetails?.coupon_type !== "QC COUPON" && (
              <div className="flex flex-row items-center pb-3">
                <div className="w-2/12">
                  <p>
                    Usage at Cart/Qty Level <span className="text-red-400">*</span>
                  </p>
                </div>
                <div className="w-1/3">
                  <div className="grid grid-cols-2 gap-3">
                    {couponDetails?.discount_level === "CART" ? (
                      <p>Cart Level</p>
                    ) : couponDetails?.coupon_type === "DISCOUNT ON MEMBERSHIP" ||
                      couponDetails?.coupon_type === "BOM" ||
                      couponDetails?.coupon_type === "SERVICE" ||
                      (couponDetails?.coupon_type === "PRODUCT" && is_membership_coupon) ? (
                      <p>Item Level</p>
                    ) : (
                      <SearchableSelectMenu
                        errorMessages={[{ message: "", type: "required" }]}
                        onSelectItem={(item) => {
                          if (item) {
                            formHook.setValue("usage_level", item.id);
                          }
                        }}
                        fieldError={formHook.formState.errors.usage_level}
                        register={formHook.register("usage_level", { required: true })}
                        selectItems={cartTypeItem}
                        placeholder="Select"
                        showTooltips={true}
                        showTypedErrors={true}
                        showDropdownIcon={true}
                        defaultSelected={cartTypeItem?.filter((oc) => oc.id === formHook.watch("usage_level"))[0]}
                        listBoxClassName="w-36"
                        className="text-gray-800 col-span-1"
                        containerClassName="w-full"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            <hr />
            {/* {couponDetails?.coupon_type === "PRODUCT" &&
              couponDetails?.discount_level?.toLowerCase() === "cart" &&
              couponDetails?.cart_discount_details?.discount_type?.toLowerCase() === "percentage" && (
                <div>
                  <h2 className="text-sm font-semibold">Visibility on App</h2>
                  <div className="flex items-center pb-2 py-2">
                    <div className="w-2/12">
                      <p>Apply Coupon Automatically</p>
                    </div>
                    <div className="w-3/12">
                      <Switch
                        checked={formHook.watch("auto_applicable")}
                        onChange={() => {
                          formHook.setValue("auto_applicable", !formHook.watch("auto_applicable"));
                        }}
                        className={`${formHook.watch("auto_applicable") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"
                          } relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
                      >
                        <span
                          aria-hidden="true"
                          className={`${formHook.watch("auto_applicable") ? "translate-x-8" : "translate-x-0"
                            } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                        />
                      </Switch>
                    </div>
                  </div>
                  <div className="flex items-center py-2">
                    <div className="w-2/12">
                      <p>Visible On App</p>
                    </div>
                    <div className="w-3/12">
                      <Switch
                        checked={formHook.watch("is_visible")}
                        onChange={() => {
                          formHook.setValue("is_visible", !formHook.watch("is_visible"));
                        }}
                        className={`${formHook.watch("is_visible") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"
                          } relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
                      >
                        <span
                          aria-hidden="true"
                          className={`${formHook.watch("is_visible") ? "translate-x-8" : "translate-x-0"
                            } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                        />
                      </Switch>
                    </div>
                  </div>
                </div>
              )} */}
            {/* {couponDetails?.coupon_type === "PRODUCT" &&
              couponDetails?.discount_level?.toLowerCase() === "item" &&
              couponDetails?.item_discount_details?.included_details?.price?.discount_price_type?.toLowerCase() ===
              "percentage" && (
                <div>
                  <h2 className="text-sm font-semibold">Visibility on App</h2>
                  <div className="flex items-center pb-2 py-2">
                    <div className="w-2/12">
                      <p>Apply Coupon Automatically</p>
                    </div>
                    <div className="w-3/12">
                      <Switch
                        checked={formHook.watch("auto_applicable")}
                        onChange={() => {
                          formHook.setValue("auto_applicable", !formHook.watch("auto_applicable"));
                        }}
                        className={`${formHook.watch("auto_applicable") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"
                          } relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
                      >
                        <span
                          aria-hidden="true"
                          className={`${formHook.watch("auto_applicable") ? "translate-x-8" : "translate-x-0"
                            } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                        />
                      </Switch>
                    </div>
                  </div>
                  <div className="flex items-center py-2">
                    <div className="w-2/12">
                      <p>Visible On App</p>
                    </div>
                    <div className="w-3/12">
                      <Switch
                        checked={formHook.watch("is_visible")}
                        onChange={() => {
                          formHook.setValue("is_visible", !formHook.watch("is_visible"));
                        }}
                        className={`${formHook.watch("is_visible") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"
                          } relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
                      >
                        <span
                          aria-hidden="true"
                          className={`${formHook.watch("is_visible") ? "translate-x-8" : "translate-x-0"
                            } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                        />
                      </Switch>
                    </div>
                  </div>
                </div>
              )} */}
            {showAppVisibility && (
              <div>
                <h2 className="text-sm font-semibold ">Visibility on App</h2>
                <div className="flex items-center pb-2 py-2">
                  <div className="w-2/12">
                    <p>Apply Coupon Automatically</p>
                  </div>
                  <div className="w-3/12">
                    <Switch
                      checked={formHook.watch("auto_applicable")}
                      disabled={isBase}
                      onChange={() => {
                        if (isBase) return;
                        formHook.setValue("auto_applicable", !formHook.watch("auto_applicable"));
                      }}
                      className={`${
                        formHook.watch("auto_applicable") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"
                      } relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${
                          formHook.watch("auto_applicable") ? "translate-x-8" : "translate-x-0"
                        } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                      />
                    </Switch>
                  </div>
                </div>
                <div className="flex items-center py-2">
                  <div className="w-2/12">
                    <p>Visible On App</p>
                  </div>
                  <div className="w-3/12">
                    <Switch
                      checked={formHook.watch("is_visible")}
                      disabled={isBase}
                      onChange={() => {
                        if (isBase) return;
                        formHook.setValue("is_visible", !formHook.watch("is_visible"));
                      }}
                      className={`${
                        formHook.watch("is_visible") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"
                      } relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${
                          formHook.watch("is_visible") ? "translate-x-8" : "translate-x-0"
                        } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                      />
                    </Switch>
                  </div>
                </div>
              </div>
            )}
            {couponDetails?.coupon_type !== "QC COUPON" && (
              <h2 className="text-sm font-semibold">Visibility on VMS</h2>
            )}
            {couponDetails?.coupon_type !== "QC COUPON" && formHook.watch("usage_level") !== "CART_LEVEL" && (
              <>
                <div className="flex items-center py-3">
                  <div className="w-2/12">
                    <p>Apply Coupon Automatically</p>
                  </div>
                  <div className="w-3/12">
                    <Switch
                      checked={formHook.watch("vms_auto_applicable")}
                      disabled={isBase}
                      onChange={() => {
                        if (isBase) return;
                        if (formHook.watch("vms_auto_applicable")) {
                          formHook.setValue("vms_auto_applicable", false);
                        } else {
                          formHook.setValue("vms_auto_applicable", true);
                        }
                      }}
                      className={`${formHook.watch("vms_auto_applicable") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"}
          relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white/75`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${formHook.watch("vms_auto_applicable") ? "translate-x-8" : "translate-x-0"}
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                      />
                    </Switch>
                  </div>
                </div>
              </>
            )}
            {couponDetails?.coupon_type !== "QC COUPON" && (
              <div>
                <div className="flex items-center py-3">
                  <div className="w-2/12">
                    <p>Visible On VMS</p>
                  </div>
                  <div className="w-3/12">
                    <Switch
                      checked={formHook.watch("vms_visible")}
                      disabled={isBase}
                      onChange={() => {
                        if (isBase) return;
                        if (formHook.watch("vms_visible")) {
                          formHook.setValue("vms_visible", false);
                        } else {
                          formHook.setValue("vms_visible", true);
                        }
                      }}
                      className={`${formHook.watch("vms_visible") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"}
          relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white/75`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${formHook.watch("vms_visible") ? "translate-x-8" : "translate-x-0"}
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                      />
                    </Switch>
                  </div>
                </div>
              </div>
            )}
            <div className="flex items-center">
              <div className="w-2/12">
                <p>Coupon Active</p>
              </div>
              <div className="w-3/12">
                <Switch
                  checked={formHook.watch("status")}
                  onChange={() => {
                    if (formHook.watch("status")) {
                      formHook.setValue("status", false);
                    } else {
                      formHook.setValue("status", true);
                    }
                  }}
                  className={`${formHook.watch("status") ? "bg-[#4D9FFF]" : "bg-[#CCCCCC]"}
          relative inline-flex h-6 w-14 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
                >
                  <span
                    aria-hidden="true"
                    className={`${formHook.watch("status") ? "translate-x-8" : "translate-x-0"}
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                  />
                </Switch>
              </div>
            </div>
          </div>
          <div className="right-5 bottom-0 fixed flex justify-end items-center gap-4 border-t-2 w-full p-3 bg-white">
            <button
              type="button"
              onClick={() => handelBackStepper()}
              className="text-xs mt-3 inline-flex w-full justify-center rounded-md bg-[#b1b5bb] px-4 py-3 font-semibold text-white ring-inset ring-gray-300 hover-bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Back
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="text-xs mt-3 inline-flex w-full justify-center items-center gap-2 rounded-md bg-[#193A6A] px-4 py-3 font-semibold text-white ring-inset ring-gray-300 hover-bg-gray-50 sm:mt-0 sm:w-auto disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {isSubmitting && (
                <svg
                  className="animate-spin h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
              )}
              {isSubmitting ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default CouponUsageComponent;
